import { render, staticRenderFns } from "./MajorMediaPage.vue?vue&type=template&id=2b4f4079&scoped=true"
import script from "./MajorMediaPage.vue?vue&type=script&lang=js"
export * from "./MajorMediaPage.vue?vue&type=script&lang=js"
import style0 from "./MajorMediaPage.vue?vue&type=style&index=0&id=2b4f4079&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f4079",
  null
  
)

export default component.exports